import React from 'react';
import { SHOP_LOCALE } from 'src/scripts/utils/constants';

const CountrySpecificFooterContent = () => {
  const { countrySpecificFooterContent } = window?.getSiteSettings() || {};
  const footerContent = countrySpecificFooterContent?.[SHOP_LOCALE]?.value;

  if (!footerContent) return null;

  return <p className="duties-disclaimer body-small white">{footerContent}</p>;
};

export default CountrySpecificFooterContent;
